import { Route, Routes } from "react-router-dom";
import { Suspense } from "react";
import { useTranslation } from "react-i18next";

import { SiteLoading } from "./components/site-loading";
import DefaultLayout from "./layouts/default";
import { title } from "./components/primitives";
import { PageNotFound } from "./pages/404";
import { AuthenticationGuard, LogoutButton, useAuth } from "./authentication";

import IndexPage from "@/pages/index";
import ApiPage from "@/pages/test-secured-api";
import PricingPage from "@/pages/pricing";
import BlogPage from "@/pages/blog";
import AboutPage from "@/pages/about";
import OpenApiPage from "./pages/openapi-api";
import ChannelPage from "./pages/channel";
import ChannelsAdminPage from "./pages/channels-admin";
import UsersAdminPage from "./pages/users-admin";

function App() {
  const { isLoading, isAuthenticated } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return <SiteLoading />;
  }

  // Gérer les erreurs
  if (!isAuthenticated && !isLoading) {
    // eslint-disable-next-line no-console
    console.log(
      "User is not authenticated but auth is not loading - likely an error condition",
    );

    return (
      <DefaultLayout>
        <section className="flex flex-col items-center justify-center gap-4 py-8 md:py-10">
          <div className="inline-block max-w-lg text-center justify-center">
            <div className="mb-4">
              <h1 className={title()}>
                {t("error")}: {t("authentication_error")}
              </h1>
            </div>
            <div>
              <LogoutButton
                showButtonIfNotAuthenticated={true}
                text={t("reload")}
              />
            </div>
          </div>
        </section>
      </DefaultLayout>
    );
  }

  return (
    <Suspense fallback={<SiteLoading />}>
      <Routes>
        <Route element={<IndexPage />} path="/" />
        <Route
          element={<AuthenticationGuard component={ApiPage} />}
          path="/api"
        />
        <Route
          element={<AuthenticationGuard component={PricingPage} />}
          path="/pricing"
        />
        <Route
          element={<AuthenticationGuard component={BlogPage} />}
          path="/blog"
        />
        <Route element={<AboutPage />} path="/about" />
        <Route
          element={<AuthenticationGuard component={ChannelPage} />}
          path="/channel/:uuid"
        />
        <Route
          element={<AuthenticationGuard component={ChannelsAdminPage} />}
          path="/channels-admin"
        />
        <Route
          element={<AuthenticationGuard component={UsersAdminPage} />}
          path="/users-admin"
        />
        <Route
          element={<OpenApiPage />}
          path="/openapi"
        />
        <Route element={<PageNotFound />} path="*" />
      </Routes>
    </Suspense>
  );
}

export default App;
